// extracted by mini-css-extract-plugin
module.exports = {"table":"style_table__3Bn74","pagination":"style_pagination__2zN3G","customDisable":"style_customDisable__3zo05","pageNumber":"style_pageNumber__33t6b"};